import React from 'react'
import styled from 'styled-components/macro'
import { em } from '../../../utils/styles'
import IconButtonBase from '../../IconButton'
import { ReactComponent as PlusIcon } from '../../Icons/icon-plus.svg'

const IconButton = styled(IconButtonBase)`
  transform: rotate(45deg);
  flex-basis: auto;
  align-self: center;
  width: ${em(30)};
  height: ${em(30)};
`

export default function RemoveButton(props) {
  return (
    <IconButton type='button' {...props}>
      <PlusIcon />
    </IconButton>
  )
}
